import React from 'react';
import image from '../Image/istockphoto-1226858173-612x612.jpg'
import html from '../Image/html.png'
import css from '../Image/CSS3_logo_and_wordmark.svg.png'
import java from '../Image/javascript_logo.png'
import react from '../Image/react.png'
import firebase from '../Image/firebase.png'
import bootstrap from '../Image/bootstrap.jpg'
import tailwind from '../Image/tailwind.png'
const Skill = () => {
    return (
        <div class=" m-12 mt-24">

            <h1 class="text-5xl text-center mt-12 font-bold">My Skills</h1>

            <div className='text-center  gap-5  lg:gap-24 lg:flex lg:justify-center '>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={html} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>HTML</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={css} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>CSS</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={java} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>JavaScript</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={react} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>React.js</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={firebase} />

                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>Firebase</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={bootstrap} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>TailWind</p>

                </div>
                <div class="py-6 mt-5">
                    <div class="avatar">
                        <div class="w-24 mask mask-squircle">
                            <img src={tailwind} />
                        </div>

                    </div>
                    <p className='text-xl text-white font-bold'>TailWind</p>

                </div>
            </div>
        </div>

    );
};

export default Skill;